import { Outlet, Link, NavLink } from 'react-router-dom';
import { motion, useScroll, useTransform } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

export default function PublicLayout() {
  const { scrollY } = useScroll();
  // Navbar : toujours visible (voile + flou dès le haut) pour lisibilité au-dessus de la photo hero,
  // se densifie un peu au scroll pour ancrer la barre.
  const navBg = useTransform(scrollY, [0, 80], ['rgba(10,31,46,0.45)', 'rgba(10,31,46,0.88)']);
  const navBorder = useTransform(scrollY, [0, 80], ['rgba(255,255,255,0.08)', 'rgba(255,255,255,0.10)']);
  const navBlur = useTransform(scrollY, [0, 80], ['blur(14px)', 'blur(18px)']);

  return (
    <div className="min-h-screen bg-primary-bg text-white flex flex-col">
      <motion.header
        style={{ background: navBg, borderColor: navBorder, backdropFilter: navBlur }}
        className="fixed inset-x-0 top-0 z-50 border-b transition-colors"
      >
        <nav className="max-w-7xl mx-auto px-4 lg:px-16 h-16 flex items-center justify-between">
          <Link to="/" aria-label="Stella Cars" className="flex items-center text-white">
            <img src="/logo.png" alt="Stella Cars" className="h-10 w-auto md:h-11" />
          </Link>
          <div className="hidden md:flex items-center gap-8 text-sm text-slate-300">
            <a href="/#process" className="hover:text-accent-gold transition">Comment ça marche</a>
            <a href="/#contact" className="hover:text-accent-gold transition">Contact</a>
            <NavLink to="/mentions-legales" className="hover:text-accent-gold transition">Mentions</NavLink>
            <NavLink to="/confidentialite" className="hover:text-accent-gold transition">RGPD</NavLink>
          </div>
          <Link
            to="/estimation"
            className="group inline-flex items-center gap-1.5 rounded-full bg-gradient-to-r from-accent-gold to-accent-goldLight px-4 py-2 text-sm font-semibold text-primary-bg shadow-gold transition hover:-translate-y-0.5"
          >
            Estimer
            <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" />
          </Link>
        </nav>
      </motion.header>

      <main className="flex-1"><Outlet /></main>

      <footer className="relative border-t border-white/5 bg-primary-bg">
        <div className="max-w-7xl mx-auto px-4 lg:px-16 py-14">
          <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
            <div>
              <img src="/logo.png" alt="Stella Cars" className="h-12 w-auto" />
              <p className="mt-4 text-sm text-slate-400 max-w-sm">
                Consultant automobile indépendant depuis 2011. Estimation, négociation et accompagnement complet pour la vente de votre véhicule.
              </p>
            </div>
            <div>
              <div className="text-xs uppercase tracking-[0.2em] text-accent-gold">Contact</div>
              <ul className="mt-4 space-y-3 text-sm text-slate-300">
                <li className="leading-relaxed">
                  <span className="block text-slate-400 text-xs uppercase tracking-wider">Adresse</span>
                  2, rue Louis et Auguste Lumière<br />77380 COMBS-LA-VILLE
                </li>
                <li>
                  <span className="block text-slate-400 text-xs uppercase tracking-wider">Téléphone</span>
                  <a href="tel:+33653873860" className="hover:text-accent-gold block">Caroline : 06 53 87 38 60</a>
                  <a href="tel:+33765859663" className="hover:text-accent-gold block">Rémy : 07 65 85 96 63</a>
                </li>
                <li>
                  <span className="block text-slate-400 text-xs uppercase tracking-wider">Email</span>
                  <a href="mailto:contact@stella-cars.com" className="hover:text-accent-gold">contact@stella-cars.com</a>
                </li>
              </ul>
            </div>
            <div>
              <div className="text-xs uppercase tracking-[0.2em] text-accent-gold">Navigation</div>
              <ul className="mt-4 space-y-2 text-sm text-slate-300">
                <li><Link to="/" className="hover:text-accent-gold">Accueil</Link></li>
                <li><Link to="/estimation" className="hover:text-accent-gold">Estimation</Link></li>
              </ul>
            </div>
            <div>
              <div className="text-xs uppercase tracking-[0.2em] text-accent-gold">Légal</div>
              <ul className="mt-4 space-y-2 text-sm text-slate-300">
                <li><Link to="/mentions-legales" className="hover:text-accent-gold">Mentions légales</Link></li>
                <li><Link to="/confidentialite" className="hover:text-accent-gold">Confidentialité</Link></li>
              </ul>
            </div>
          </div>
          <div className="mt-12 border-t border-white/5 pt-6 text-xs text-slate-500">
            © {new Date().getFullYear()} Stella Cars. Tous droits réservés.
          </div>
        </div>
      </footer>
    </div>
  );
}
